import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { Lote } from '../types/lote.types';

interface LoteStore {
  lotes: Lote[];
  loading: boolean;
  setLotes: (lotes: Lote[]) => void;
  setLoading: (loading: boolean) => void;
}

export const useLoteStore = create<LoteStore>()(
  devtools(
    (set) => ({
      lotes: [],
      loading: false,
      setLotes: (lotes) => set({ lotes }),
      setLoading: (loading) => set({ loading }),
    }),
    { name: 'LoteStore' }
  )
);
